import React from 'react'
import { H2, H3, BodyCopy } from '@components/Globals'
import { A } from '@components/Button'
import ALink from '@components/A'
import { ProfileCard } from '@components/Card/index'
import { StyledEventButton } from '@components/Button/style'
import { nodeLocaleToEnglishLanguage } from '@utils'
import {
  StyledImage,
  StyledImageContainer,
  StyledH4,
  StyledALink,
} from '../style'
import Box from '@components/Box'
import { useLocale } from '@hooks'

const InsightsDetailSidebarContent = ({
  practiceAreas,
  subscribeLink,
  forMoreInformation,
  sanitizedFeaturedImage,
  sidebarTitle,
}) => {
  const isFeaturedProfessional = sanitizedFeaturedImage?.isFeaturedProfessional

  const { locale } = useLocale()

  const activeAuthors = forMoreInformation?.filter(a => a.active)

  const localizedPracticeAreas =
    practiceAreas?.length > 0 &&
    practiceAreas.filter(
      i =>
        !i.displayOnSites ||
        (i.displayOnSites &&
          i.displayOnSites.includes(nodeLocaleToEnglishLanguage[locale]))
    )

  return (
    <>
      {sanitizedFeaturedImage && (
        <Box width={isFeaturedProfessional ? '70%' : '100%'}>
          <StyledImageContainer
            pb={isFeaturedProfessional ? '119.65%' : '52.25%'}
            mb={2}
            bg="white"
          >
            <ALink {...sanitizedFeaturedImage?.linkData}>
              <StyledImage
                src={sanitizedFeaturedImage?.image}
                alt={sanitizedFeaturedImage?.alt}
              />
            </ALink>
          </StyledImageContainer>
          {sanitizedFeaturedImage?.caption && (
            <StyledH4 color="gray" mb={2} fontWeight="400" fontSize={2}>
              {sanitizedFeaturedImage?.caption}
            </StyledH4>
          )}
        </Box>
      )}

      {localizedPracticeAreas && (
        <>
          <H3
            marginBottom={12}
            fontSize="14px"
            color="gray"
            className="qtph-insightspge-practiceareastitle-txt"
          >
            Practice Areas
          </H3>
          {localizedPracticeAreas?.map(p => (
            <BodyCopy key={p.id}>
              <StyledALink to={p?.slug} contentType="ContentfulPracticeArea">
                {p.title}
              </StyledALink>
            </BodyCopy>
          ))}
          <br />
        </>
      )}
      {subscribeLink && (
        <>
          <H2
            marginTop={40}
            fontSize="30px"
            lineHeight="36px"
            normalCase
            marginBottom={20}
          >
            Sign up for our insights
          </H2>
          <A none href={`${subscribeLink}`}>
            <StyledEventButton
              width="250px"
              height="62px"
              marginBottom="10px"
              active
            >
              Subscribe to Insights
            </StyledEventButton>
          </A>
        </>
      )}
      {activeAuthors?.length > 0 &&
        activeAuthors[0]?.name !== 'Paul Hastings Professional' && (
          <>
            {sidebarTitle ? (
              <H2
                fontSize="1rem"
                marginTop={30}
                className="qtph-insightspge-formoreinformation-txt"
              >
                {sidebarTitle}
              </H2>
            ) : (
              <H2
                fontSize="1rem"
                marginTop={30}
                className="qtph-insightspge-formoreinformation-txt"
              >
                For More Information
              </H2>
            )}

            {activeAuthors?.map(a => (
              <React.Fragment key={a.id}>
                <ProfileCard
                  person={a}
                  id={a.id}
                  displayTitle
                  displayDepartment
                  displayContact
                  displayAvatar
                  defaultFontSize={16}
                  contactUs
                  float="left"
                  flexDirection
                  height="auto"
                  padding="10px 0 0"
                />
              </React.Fragment>
            ))}
          </>
        )}
    </>
  )
}

InsightsDetailSidebarContent.propTypes = {}

export default InsightsDetailSidebarContent
